import { Component, Input, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import {
  UpdateContactIdRequest,
  UpdateContactsCommand,
} from 'src/app/core/api/models';
import { ContactsService } from 'src/app/core/api/services';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { ContactsFormComponent } from '../../contacts-form/contacts-form.component';
@Component({
  selector: 'app-contacts-by-cellphone-form',
  templateUrl: './contacts-by-cellphone-form.component.html',
  imports: [CommonModule, ReactiveFormsModule, BaseFormModule, MatInputModule],
})
export class ContactsByCellPhoneFormComponent
  extends ContactsFormComponent
  implements OnInit
{
  @Input() selectedContacts: UpdateContactIdRequest[];
  @Input() mobileNumber: string;

  constructor(protected currentService: ContactsService) {
    super(currentService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.model.cellPhone = this.mobileNumber;
    this.title = 'pages.contactsByCellPhone.form.editTitle';
  }

  //#region Api

  //Update
  baseUpdateApi(model: UpdateContactsCommand) {
    this.unSubs();

    this.loading = true;
    model.contacts = this.selectedContacts;

    this.currentService
      .contactsUpdateContacts({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  checkCreateOrUpdate() {
    if (this.loading || !this.form.valid) return;

    this.baseUpdateApi(this.model);
  }

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;
    this.checkCreateOrUpdate();
  }
}
